import { featureToggleSelector } from './featureToggleSelector';
import { IState } from '../../store';

export const selectMortageMiniCalculatorEnabled = (state: IState) =>
  featureToggleSelector(state).isMortgageCalculatorInObjectCardEnabled;
